export type FilterType = | 'contains' | 'equals' | 'start'

export type TypePasswordProps = | 'password' | 'text'
export type AlertType = | "DANGER" | "WARNING" | "SUCCESS"

export type HttpParams = {
    chave: string
    valor: string
}

export const KEY_CODE_ESCAPE = "Escape"
export const KEY_CODE_NUMERIC_ENTER = "NumpadEnter"
export const KEY_CODE_ENTER = "Enter"

export const TablePages = [5, 10, 15, 20, 30, 50, 100]

export type method = "get" | "post" | "delete" | "put"
export type TipoMovimentacao = "E" | "S"
export type TipoSangriaSuprimento = "A" | "S"
export type TPessoa = "FISICA" | "JURIDICA"

export type TipoLanctoCaixa = "D" | // débito
    "C" // crédito

export type IndPag = | "0" // pagamento à vista;
    | "1" // pagamento à prazo;
    | "2" // outros.

export type FinNFe =
    | "1" // NF-e normal
    | "2" // NF-e complementar
    | "3" // NF-e de ajuste

export type TEntSai = | 'E' // Entrada 
    | 'S' // Saída
    | '' // Nenhum Tipo Selecionado

export type AmbienteNFe = 'H' | 'P'

export type TipoProduto =
    | "P" // Produto 
    | "M" // Matéria Prima
    | "S" // Serviço

export type OrigMercadoria =
    //| '-1' /* vazio. */
    | '0' /* Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8. */
    | '1' /* Estrangeira – Importação direta, exceto a indicada no código 6 */
    | '2' /* Estrangeira – Adquirida no mercado interno, exceto a indicada no código 7. */
    | '3' /* Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento). */
    | '4' /* Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967, 
                                 e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007.*/
    | '5' /* Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento).*/
    | '6' /* Estrangeira – Importação direta, sem similar nacional, constante em lista de Resolução CAMEX e gás natural.*/
    | '7' /* Estrangeira – Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural.*/
    | '8' /* Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento).*/

export type TipoVariacao =
    | "V" /* Variação */
    | "S" /* SubVariação */

export type ModalidadeFrete =
    | 0   /* Por conta do emitente */
    | 1   /* Por conta do destinatário/remetente*/
    | 2   /* Por conta de terceiros*/
    | 9   /* Sem frete. (V2.0)*/


export type InputsRefs = {
    [key: string]: React.MutableRefObject<any | null>
}

export const error99 = () => {
    [
        '@ecommerce/hash',
        '@ecommerce/name',
        '@ecommerce/tema',
        '@ecommerce/cor_tema',
        '@ecommerce/cor_bg_menu',
        '@ecommerce/cor_bg_nav',
        '@ecommerce/cor_barra',
        '@ecommerce/dados_empresa',
        'imageLogo',
        '@ecommerce/desc_sub_variacao',
        '@ecommerce/desc_variacao',
        '@ecommerce/idVariacao',
        '@ecommerce/idJuros',
        '@ecommerce/diasJuros',
        '@ecommerce/taxa_juros',

    ].forEach((item) => localStorage.removeItem(item));

    window.location.href = '/login';
};

// ------------------------------------------------------------------- NOTA DE ENTRADA FISCAL -------------------------------------------------------------------------------------------

export type NFEntrada = {
    id?: number,
    idFornecedor: number,
    numNF: number,
    dtEmissao?: string,
    dtChegada?: string,
    pagamento?: string,
    modelo?: string,
    serie?: string,
    finalidade?: string,
    idNatOp: number,
    vlProdutos: number,
    vlNF: number,
    vl_desconto: number,
    vl_frete: number,
    vl_seguro: number,
    vl_outras: number,
    vl_ipi: number,
    vl_bc_icms: number,
    v_icms: number,
    vl_bc_st: number,
    vl_st: number,
    vl_pis: number,
    vl_cofins: number
    mod_frete: number,
    id_transp: number
}

export type NFEntraItem = {
    id: number,
    nitem: number,
    id_produto: number,
    descricao: string,
    qtd: number,
    unid_c: string,
    contem: number,
    vl_unit: number,
    vl_tot: number,
    vl_desc?: number,
    vl_seg?: number,
    vl_out?: number,
    vl_frete?: number,
    vl_bc_pis?: number,
    aliq_pis?: number,
    vl_pis?: number,
    cod_st_pis?: string,
    vl_bc_cofins?: number,
    aliq_cofins?: number,
    vl_cofins?: number,
    vl_bc_icms?: number,
    aliq_icms?: number,
    aliq_red_icms?: number,
    vl_icms?: number,
    vl_bc_ipi?: number,
    aliq_ipi?: number,
    vl_ipi?: number,
    vl_bc_st?: number,
    aliq_st?: number,
    vl_st?: number,
    mod_bc_st?: number,
    pmvast?: number,
    origem?: number,
    cst_icms?: string,
    cfop?: string,
    indtot?: number,
    grade?: string,
}

export type CstICMS = {
    id: string,
    cod_cst: string,
    description: string,
}

export type ParcelamentoDupPagar = {
    id: number,
    num_doc: string,
    serie: string,
    valor: number,
    id_fornecedor: number,
    id_grupo_despesa: number,
    id_subgrupo_despesa: number,
    dtEmissao: string,
    dt_vencimento: string,
    observacao: string,
    nomeFornecedor: string
}

export type NFFilter = {
    id: number,
    dt_emissao: string,
    dt_chegada: string,
    id_fornecedor: number,
    id_empresa: number,
    indPag: number,
    vl_desconto: number,
    vl_frete: number,
    vl_outras: number,
    vl_seguro: number,
    vl_produtos: number,
    vl_ipi: number,
    vl_nf: number,
    vl_bc_icms: number,
    v_icms: number,
    vl_bc_st: number,
    vl_st: number,
    vl_pis: number,
    vl_cofins: number,
    id_transp: number,
    modelo: number,
    serie: number,
    num_nf: number,
    fin_nfe: number,
    id_nat_op: number,
    id_user_insert: number,
    dt_cadastro: string,
    id_user_last_update: number,
    dh_last_update: string,
    dh_confirm_nf: string,
    id_user_confirm_nf: number,
    nome_fantasia: string,
    name_user_insert: string,
    duplicatasPagarList?: ParcelamentoDupPagar[]
}

export type RelatorioNF = {
    id: number,
    dt_emissao: string,
    dt_chegada: string,
    id_fornecedor: number,
    id_empresa: number,
    indPag: number,
    vl_desconto: number,
    vl_frete: number,
    vl_outras: number,
    vl_seguro: number,
    vl_produtos: number,
    vl_ipi: number,
    vl_nf: number,
    vl_bc_icms: number,
    v_icms: number,
    vl_bc_st: number,
    vl_st: number,
    vl_pis: number,
    vl_cofins: number,
    id_transp: number,
    modelo: number,
    serie: number,
    num_nf: number,
    fin_nfe: number,
    id_nat_op: number,
    id_user_insert: number,
    dt_cadastro: string,
    id_user_last_update: number,
    dh_last_update: string,
    dh_confirm_nf: string,
    id_user_confirm_nf: number,
    mod_frete: number,
    nome_fantasia: string,
    nome_user_insert: string,
    nome_transp: string,
    itensNF: [],
    dupPagarList?: ParcelamentoDupPagar[]
}

export type itensNF = {
    id: number,
    nitem: number,
    id_produto: number,
    desc_prod: string,
    qtd: number,
    unid_c: string,
    contem: number,
    vl_unit: number,
    vl_total: number,
    vl_desc: number,
    vl_seg: number,
    vl_out: number,
    vl_frete: number,
    vl_bc_pis: number,
    aliq_pis: number,
    vl_pis: number,
    st_pis_cofins: string,
    vl_bc_cofins: number,
    aliq_cofins: number,
    vl_cofins: number,
    vl_bc_icms: number,
    aliq_icms: number,
    aliq_red_icms: number,
    vl_icms: number,
    vl_bc_ipi: number,
    aliq_ipi: number,
    vl_ipi: number,
    vl_bc_st: number,
    aliq_st: number,
    aliq_red_st: number,
    vl_st: number,
    mod_bc_st: number,
    pmvast: number,
    origem: string,
    cst_icms: string,
    cfop: number,
    dh_insert: string,
    id_user_insert: number,
    id_user_last_update: number,
    dh_last_update: string,
    indtot: number,
    status: string,
    dh_cancel: string,
    id_user_cancel: number,
    motivo_cancel: string,
    name_user_insert: string
}

// ------------------------------------------------------------------- CLIENTE -------------------------------------------------------------------------------------------
export type Clientes = {
    id: number,
    id_empresa?: number,
    id_cidade: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    motivo_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    tipo_pessoa: string,
    cnpj_cpf: string,
    nome: string,
    nome_fantasia: string,
    dt_nascimento?: string,
    ativo: string,
    ie_rg: string,
    observacao?: string,
    cep?: string,
    endereco?: string,
    bairro?: string,
    numero?: number,
    complemento?: string,
    uf: string,
    nome_cidade: string,

    description: string
}

export type ClientesSearchBox = {
    id: number,
    description: string
}

export type ClientesAttributes = {
    estados: Estado[],
    cidades: Cidade[],
    cliente: Clientes,
    usuarios: Usuarios[],
}

export type ContatoCliente = {
    id: number,
    nome: string,
    telefone: string,
    celular: string,
    email?: string,
    descricao?: string,
    id_cliente?: number,
    empresaId?: number,


    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

//------------------------------------------------------------------- MOVIMENTAÇÃO -------------------------------------------------------------------------------------------
export type MovimentacaoProduto = {
    dhInsert: string,
    observacao: string,
    tipo: TipoMovimentacao,
    qtd: number,
    acumulado: number,
    doc?: string,
}

export type DadosMovimentacao = {
    movimentacao: MovimentacaoProduto[],
    totEntrada: number,
    totSaida: number,
}

// ------------------------------------------------------------------- PRODUTO -------------------------------------------------------------------------------------------
export type Produto = {

    id: number,
    id_empresa?: number,
    id_grupo?: Grupo,
    id_marca?: Marca,
    id_sgrupo?: SubGrupo,
    id_tributacao?: GrupoTrib,
    id_unid_medida?: UnidMedida,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    descricao: string,
    cod_barra?: string,
    referencia?: string,
    preco_c?: number,
    preco_v?: number,
    peso?: number,
    estoque_minimo: number,
    ativo: boolean,
    ncm: string,
    cod_cest: string,
    origem_mercadoria: OrigMercadoria,
    tipo: TipoProduto,
    estoque: number,
    estoque_fisico: number,
    urlImage?: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
    qtd?: number,
    total?: number,
    grade?: GradeProduto,
    description: string,
    isGrade?: boolean,
    pICMS?: number,
    codStPisCofins?: string,
    cfopEntDentro?: string,
    cfoEntFora?: string,
    cstIcmsDentro?: string,
    cstIcmsFora?: string,
    pPis?: number,
    pCofins?: number,

    nome_fornecedor?: string,
    dt_ult_compra?: string,
    id_fornec_ult_compra?: number,
    vl_custo_ult_compra?: number,
    num_nf_ult_compra?: number,
    qtd_ult_compra?: number,
}

export type ProdutoEstoque = {
    id: number,
    id_empresa: number,
    descricao: string,
    estoque_fisico: number,
    preco_c: number,
    preco_v: number,
    ativo: boolean,
    total_custo: number,
    total_venda: number,
    description: string,
    grades: [
        {
            id?: number,
            idProduto: number,
            codBarraRef: string,
            variacao: VariacaoProduto,
            subVariacao?: VariacaoProduto,
            saldoEstoque: number,
        }
    ]
}

export type ProdAttributes = {
    grupos: Grupo[],
    marcas: Marca[],
    gTrib: GrupoTrib[],
    unidades: UnidMedida[],
    produto?: Produto,
    sgrupos: SubGrupo[],
    imagens?: ProdImages[],
    variacaoProdutos?: VariacaoProduto[],
    descVariacao?: string,
    descSubVariacao?: string,
    grade: GradeProduto[],
}

export type ProdImages = {
    id: number,
    idProd: number,
    url: string,
    loading?: boolean,
    imagem?: File,
}

export type VariacaoProduto = {
    id: number,
    description: string,
    tipo: TipoVariacao,
}

export type GradeProduto = {
    id?: number,
    idProduto: number,
    codBarraRef: string,
    variacao: VariacaoProduto,
    subVariacao?: VariacaoProduto,
    saldoEstoque: number,
    valorEntrada?: number,
}

// ------------------------------------------------------------------- MARCAS -------------------------------------------------------------------------------------------
export type Marca = {
    id: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    description: string,

    motivo_exclusao?: string,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- EMPRESAS -------------------------------------------------------------------------------------------
export type Empresa = {
    id: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    id_parceiro: number,
    id_cidade: number,

    motivo_exclusao?: string,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    razao: string,
    nome_fantasia: string,
    endereco?: string,
    bairro?: string,
    numero?: string,
    cep?: string,
    complemento?: string,
    cnpj_cpf: string,
    ie_rg?: string,
    cnae?: string,
    regime_tributario: RegimeTributario,
    ativo: boolean,
    uf?: string,

    url_logo?: string,
    cidade: string,
    parceiro: string,
}

export type EmpresaAttributes = {
    estados: Estado[],
    cidades: Cidade[],
    contatos: ContatoEmpresa[],
    empresa: Empresa,
    observacoes: ObsEmpresa[],
    parceiros: Parceiro[],
}

export type ContatoEmpresa = {
    id: number,
    nome: string,
    telefone: string,
    celular: string,
    email?: string,
    setor?: string,
    empresaId?: number,

    id_user_insert?: number,
    id_user_last_update?: number,
    dt_cadastro?: string,
    dt_last_update?: string,
    name_user_insert?: string,
    name_user_last_update?: string
}

export type ObsEmpresa = {
    id: number,
    titulo: string,
    conteudo: string,
    dtCadastro: string,
    usuario: string,
}

// ------------------------------------------------------------------- GRUPOS -------------------------------------------------------------------------------------------
export type Grupo = {
    id: number,
    description: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- SUBGRUPOS -------------------------------------------------------------------------------------------
export type SubGrupo = {
    id: number,
    description: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- NATUREZA OPERAÇÃO -------------------------------------------------------------------------------------------
export type NaturezaOperacao = {
    id: number,
    descricao: string,
    cfop_entrada: string,
    cfop_saida: string,
    cfop_interno: string,
    cfop_externo: string,
    cst_dentro: string,
    cst_fora: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- UNIDADE MEDIDA -------------------------------------------------------------------------------------------
export type UnidMedida = {
    id: number,
    description: string,
    fator_conversao: number,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- FORMA PAGAMENTO -------------------------------------------------------------------------------------------
export type FormaPagamento = {
    id: number,
    descricao: string,
    pacrescimo: number,
    pdesconto: number,
    ordem: number,
    vl_minimo: number,
    tipo: string,
    id_empresa?: number,
    id_conta: number,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    numItem?: number,
    valor?: number,

    description: string,
    crediario: string,
}

export type FormaPagamentoSearchBox = {
    id: number,
    description: string
}

export type FormaPagamentoAttributes = {
    formaPagamento: FormaPagamento,
    contas: Conta[]
}

export type LanctoFormaPag = {
    id_fpagto: number,
    description?: string,
    valor: number
}

// ------------------------------------------------------------------- TRIBUTAÇÃO -------------------------------------------------------------------------------------------
export type GrupoTrib = {
    id: number,
    descricao?: string,
    pICMS?: number,
    pPIS?: number,
    pCOFINS?: number,
    cstPisCofins?: string,
    cfopSDentro?: string, // CFOP de saída dentro do estado;
    cfopSFora?: string,  // CFOP de saída fora do estado;
    cfopEdentro?: string, // CFOP de entrada dentro do estado;
    cfopEfora?: string, // CFOP de entrada fora do estado;
    cstICMSDentro?: string, // CST do ICMS dentro do estado;
    cstICMSFora?: string, // CST do ICMS fora do estado;

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string

    description: string,
}

export type RegimeTributario = {
    sigla: string,
    descricao: string,
}

// ------------------------------------------------------------------- FORNECEDORES -------------------------------------------------------------------------------------------
export type Fornecedor = {

    id: number,
    id_empresa?: number,
    id_origem?: number,
    endereco: string,
    bairro?: string,
    cep?: string,
    id_cidade: number,
    ativo: boolean,
    cnpj_cpf: string,
    nome: string,
    nome_fantasia: string,
    numero?: string,
    observacao?: string,
    tipo_pessoa: string,
    uf: string,
    ie_rg?: string,
    nome_cidade: string,
    complemento?: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string

    description: string,

}

export type FornecedorSearchBox = {
    id: number,
    description: string
}

export type FornecedorAttributes = {
    estados: Estado[],
    cidades: Cidade[],
    fornecedor: Fornecedor,
}

export type ContatoFornecedor = {
    id: number,
    nome: string,
    telefone: string,
    celular: string,
    email?: string,
    setor?: string,
    id_fornecedor?: number,
    empresaId?: number,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

// ------------------------------------------------------------------- GRUPO DESPESA -------------------------------------------------------------------------------------------
export type GrupoDespesa = {
    id: number,
    id_sgrupo_despesa: number,
    id_empresa?: number,
    description: string,
    desc_sgrupo?: string,
    classificacao: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

export type GrupoDespesaSearchBox = {
    id: number,
    description: string
}

export type grupoDespesaAttributes = {
    grupoDespesa: GrupoDespesa,
    subGrupoDespesa: SubGrupoDespesa[],
}

// ------------------------------------------------------------------- SUBGRUPO DESPESA -------------------------------------------------------------------------------------------
export type SubGrupoDespesa = {
    id: number,
    description: string,
    id_empresa?: number,
    idSubGrupo?: number,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

export type SubGrupoDespesaSearchBox = {
    id: number,
    description: string
}

// ------------------------------------------------------------------- TRANSPORTADORAS -------------------------------------------------------------------------------------------
export type Transportadora = {
    id: number,
    razao: string,
    nome_fantasia: string,
    endereco: string,
    bairro?: string,
    numero?: string,
    cep?: string,
    id_cidade: number,
    complemento?: string,
    ie_rg?: string,
    id_empresa?: number,
    observacao?: string,
    tipo_pessoa: string,
    cnpj_cpf: string,
    ativo: boolean,
    uf: string,
    nome_cidade?: string,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string

    description: string,
}

export type ContatoTransportadora = {
    id: number,
    nome: string,
    telefone: string,
    celular: string,
    email?: string,
    setor?: string,
    id_transp?: number,
    empresaId?: number,

    id_user_insert?: number,
    id_user_last_update?: number,
    dt_cadastro?: string,
    dt_last_update?: string,
    name_user_insert?: string,
    name_user_last_update?: string
}

export type TransportadoraAttributes = {
    estados: Estado[],
    cidades: Cidade[],
    transportadora: Transportadora,
}

// ------------------------------------------------------------------- CONFIGURAÇÕES -------------------------------------------------------------------------------------------
export type Config = {

    id: number,
    desc_variacao: string,
    desc_sub_variacao: string,
    id_empresa: number,
    id_user_insert: number,
    dt_cadastro: string

}

export type TaxaJuros = {

    id: number,
    taxa_juros: number,
    dias: number,
    id_empresa: number,
    id_user_insert: number,
    dt_cadastro: string,
    id_user_last_update: number,
    dt_last_update: string

}

export type AttributesConfig = {
    config?: Config,
    juros?: TaxaJuros
}

// ------------------------------------------------------------------- CONFIGURAÇÕES NFe -------------------------------------------------------------------------------------------
export type ConfigNFe = {
    id: number,
    idEmpresa: number,
    ambiente?: AmbienteNFe,
    pathCertificado?: string,
    dtCadastro?: string,
    idUserInsert?: number,
    certFile?: File,
    cscNFCe?: string,
    cscIdNFCe?: string,
    senhaCert?: string,
}

// ------------------------------------------------------------------- ESTOQUE -------------------------------------------------------------------------------------------
export type AcertoEstoque = {
    id?: number,
    idGrade?: string,
    dhInsert?: string,
    idEmpresa?: number,
    idUsuario?: number,
    idProduto: number,
    qtd: number,
    observacao?: string,
    tipo: string,
}

// ------------------------------------------------------------------- PDF -------------------------------------------------------------------------------------------
export type HeaderPDF = {
    text: string,
    bold?: boolean,
    fontSize?: number,
    margin?: number[],
}

// ------------------------------------------------------------------- USUARIOS -------------------------------------------------------------------------------------------
export type Usuarios = {
    id: number,
    nome: string,
    email: string,
    password: string,
    ativo: boolean,
    id_empresa: number, // tem que conferir
    celular?: string,
    token?: string,
    description: string
}

export type NewUsuarios = {
    name?: string,
    oldPassword?: string,
    newPassword?: string,
    repeatPassword?: string,

}

// ------------------------------------------------------------------- CIDADE e ESTADO -------------------------------------------------------------------------------------------
export type Cidade = {
    id: number,
    description: string,
    uf: string,
    codIBGE: number,
}

export type Estado = {
    id: number,
    description: string,
    sigla: string,
    codIBGE: number,
}

export type CidadeEstadoAttributes = {
    estados: Estado[],
    cidades: Cidade[],
}

// ------------------------------------------------------------------- API -------------------------------------------------------------------------------------------
export type RetAPI = {
    error: boolean,
    msg?: string,
    id?: number,
    data?: any,
    name_user_insert?: string,
    name_user_last_update?: string,
    dt_cadastro?: string,
    dt_last_update?: string,
    url_logo?: string,
    field?: string,

    valor_total_bruto?: number,
    valor_total_desconto?: number,
    valor_total_liquido?: number,
    quantidade_registro?: number,

    //clientes?: Clientes
}

// ------------------------------------------------------------------- CNPJ -------------------------------------------------------------------------------------------
export type DadosCNPJ = {
    abertura: string,
    bairro: string,
    cep: string,
    cnpj: string,
    compl?: string,
    email?: string,
    fantasia?: string,
    logradouro: string,
    municipio: string,
    razao: string,
    numero?: string,
    uf?: string,
    id_cidade?: number,
    id_uf?: number,
    registro?: boolean,
    excluido?: boolean
}

// ------------------------------------------------------------------- CFOP -------------------------------------------------------------------------------------------
export type CFOP = {
    id: number,
    codigo: number,
    description: string,
}

// ------------------------------------------------------------------- SERIE -------------------------------------------------------------------------------------------
export type Serie = {
    id: number,
    num_doc: number,
    modelo: number,
    serie: number,
    id_empresa: number,
    dt_cadastro?: string,
    id_user_insert?: number,
    name_user_insert?: string,
    dt_last_update?: string,
    name_user_last_update?: string
}

// ------------------------------------------------------------------- CONTAS À PAGAR -------------------------------------------------------------------------------------------
export type DadosRelCtaPagar = {
    ctaPagar: contaAPagar[],
    total: number,
    qtdDup: number,
}

export type DadosRelDiaCtaPagar = {
    dt_vencimento: string,
    total: number,
    qtd_dup: number,
    acumulado: number
    somaTotal: number,
    somaDup: number
}

export type contaAPagar = {
    id: number,
    id_fornecedor: number,
    id_grupo_despesa: number,
    id_sgrupo_despesa?: number,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_vencimento: string,
    dt_liquidacao: string,
    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,

    nome_fornecedor: string,
    desc_grupo_despesa: string,
    valor: number,
    num_doc: string,
    serie: number,
    observacao: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    selected?: boolean,
    id_bordero: number,

}

export type contaAPagarAttributes = {
    contaAPagar: contaAPagar,
    fornecedor: FornecedorSearchBox[],
    grupoDespesa: GrupoDespesaSearchBox[],
    subGrupoDespesa?: SubGrupoDespesaSearchBox[],
}

export type LanctoContaPag = {
    id_conta: number,
    description?: string,
    valor: number
}

export type ParamsLiqDupPagar = {
    dtpagto: string,
    observacao?: string,
    vl_desc: number,
    vl_outros: number,
    vl_bruto: number,
    vl_pagar: number,
    senha_usuario: string,
    duplicatas: number[],
    lanctoContasList: LanctoContaPag[],
}

export type ParamsEstDupPagar = {
    senha_usuario: string,
    duplicatas: number[],
    lanctoContasList: LanctoContaPag[],
    bordero: number[],
    motivo: string
}

export type DadosBorderoDup = {
    valor: number,
    id_bordero: number,
    dt_liquidacao: string,
    obs_liquidacao: string,
    selected?: boolean,
    qtd: number,
}

export type DadosBorderoDupGeral = {
    ctaPagar: DadosBorderoDup[]
    total: number,
    qtd: number,
}


// ------------------------------------------------------------------- CONTAS À RECEBER -------------------------------------------------------------------------------------------
export type DadosRelCtaReceber = {
    ctaReceber: ContaAReceber[],
    total: number,
    qtdDup: number,
}

export type DadosRelCtaReceberEstorno = {
    ctaReceber: ContaAReceberEstorno[],
    total: number,
    qtdDup: number,
}

export type DadosRelCtaReceberPDF = {
    ctaReceber: ContaAReceber,
    //cliente : Clientes
}

export type DadosBordero = {
    valor: number,
    id_bordero: number,
    name_user: string,
    name_cliente: string,
    dt_baixa: string,
    obs_baixa: string
}

export type DadosImpressaoBordero = {
    duplicata: ContaAReceber[],
    clientes: Clientes,
    pagamentos: PagamentosRecibo[]
}

export type PagamentosRecibo = {
    valor: number,
    descricao: string
}

export type ContaAReceber = {
    id: number,
    id_cliente?: number,
    id_venda?: number,
    id_user_baixa?: number,

    id_user_insert: number,
    id_user_last_update?: number,

    data_vencimento: string,
    dt_baixa?: string,
    dt_cadastro: string,
    dt_last_update?: string,

    serie: number,
    observacao?: string,
    valor: number,
    valor_original: number,
    vl_desconto?: number,
    vl_juros?: number,

    id_user_cancel: number,
    dh_cancel: string,
    motivo_cancel: string,

    obs_baixa: string,

    nome_cliente?: string,

    name_user_insert: string,
    name_user_baixa: string,
    name_user_cancel: string,
    name_user_last_update: string

    id_origem?: number,
    id_bordero?: number,

    selected?: boolean,
    qtdDup?: number

}

export type ContaAReceberAttributes = {
    contaAReceber: ContaAReceber,
    cliente: ClientesSearchBox[],
}

export type ContaAReceberEstorno = {
    id: number,
    qtdDup: number,
    id_bordero?: number,
    valor: number,
    nome: string
}

export type contaAReceberLiquidar = {
    tipo_baixa: string,
    id_cliente: number,
    valor_baixa: number,
    valor_juros: number,
    taxa_juros: number,
    diasJuros: number,
    valor_desconto: number,
    dtpagto: string,
    senha_usuario: string,
    observacao: string,
    duplicatas: number[],
    pagamentos: LanctoFormaPag[]

}

export type ParamsEstDupReceber = {
    senha_usuario: string,
    motivo: string,
    duplicatas: number[],
    pagamentos: LanctoFormaPag[]
    bordero: number[];
}

export type taxaAttributes = {
    id: number,
    id_empresa: number,
    taxa_juros: number,
    dt_cadastro: string,
    id_user_insert: number,
    id_user_last_update?: number,
    dt_last_update?: string,
}


// ------------------------------------------------------------------- PARCEIROS -----------------------------------------------------------------------------------------------
export type ParceiroAttributes = {
    estados: Estado[],
    cidades: Cidade[],
    parceiros: Parceiro,
    uf?: string,
}

export type Parceiro = {
    id: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    motivo_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    razao: string,
    nome_fantasia: string,
    endereco: string,
    bairro?: string,
    cep?: string,
    id_cidade: number,
    tipo_pessoa: string,
    cnpj_cpf: string,
    ie_rg?: string,
    complemento?: string,
    observacao?: string,
    ativo: string,
    numero?: string,
    telefone?: string,
    celular?: string,
    contato?: string,
    email?: string,
    nome_cidade?: string,
    uf?: string,
    idUF?: number,

    description: string

}

// ------------------------------------------------------------------- CONTAS -------------------------------------------------------------------------------------------
export type Conta = {
    id: number,
    descricao: string,
    description: string,
    id_empresa?: number,

    motivo_exclusao?: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_exclusao?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string
}

export type ContasSearchBox = {
    id: number,
    description: string
}


// ------------------------------------------------------------------- CEP -------------------------------------------------------------------------------------------
export type DadosCEP = {
    cep: string,
    logradouro: string,
    complemento: string,
    bairro: string,
    cidade: string,
    uf: string,
    ibge: number,
}


// ------------------------------------------------------------------- VENDAS -------------------------------------------------------------------------------------------
export type Vendas = {
    item: number,
    descricao: string,
    qtd: number,
    unidade: string,
    total: number,
}

export type ItensVendas = {
    id_venda: number,
    id_produto: number,
    desc_prod: string,
    cod_barra: string,
    qtde: number,
    vl_unit: number,
    vl_tot: number,
    referencia: string,
    idGrade: number,
    numItem?: number,
    obsItem?: string,

    vl_custo?: number,
    cst_icms?: string,
    origem_produto?: string,
    vl_desc?: number,
    vl_bc_icms?: number,
    p_icms?: number,
    vl_icms?: number,
    vl_bc_pis_cofins?: number,
    p_pis?: number,
    vl_pis?: number,
    p_cofins?: number,
    vl_cofins?: number,
    cst_pis_cofins?: string,
    vl_bc_st?: number,
    vl_st?: number,
    vl_frete?: number

}

export type VendasRelatorio = {

    bairro_consumidor: string,
    cep_consumidor: string,
    cpf_cnpj: string,
    data_hora: string,
    dh_cancel: string,
    dh_faturamento: string,
    dt_last_update: string,
    id: number,
    id_cidade_consumidor: number,
    id_cliente: number,
    id_empresa: number
    id_user_cancel: number,
    id_user_faturamento: number,
    id_user_insert: number,
    id_user_last_update: number,
    id_user_venda?: number,
    name_user_insert: string,
    nome_cliente: string,
    nome_consumidor: string,
    num_nf: string,
    numero_consumidor: string,
    observacao: string,
    qtd_itens: number,
    rua_consumidor: string,
    status: string,
    vl_acre: number,
    vl_bc_icms: number,
    vl_bc_pis_cofins: number,
    vl_bc_st: number,
    vl_bruto: number,
    vl_cofins: number,
    vl_desc: number,
    vl_frete: number,
    vl_icms: number,
    vl_liquido: number,
    vl_pis: number,
    vl_st: number,
}

export type RelatorioConsultaVendas = {

    id: number,
    data_hora: string,
    vl_bruto: number,
    qtd_itens: number,
    vl_desc: number,
    vl_troco: number,
    vl_acre: number,
    vl_liquido: number,
    id_user_insert: number,
    id_cliente: number,
    status: string,
    observacao: string,
    vl_bc_icms: number,
    vl_icms: number,
    vl_bc_pis_cofins: number,
    vl_pis: number,
    vl_cofins: number,
    vl_bc_st: number,
    vl_st: number,
    vl_frete: number,
    id_user_last_update: number,
    dt_last_update: string,
    dh_faturamento: string,
    num_nf: number,
    id_user_faturamento: number,
    id_empresa: 10,
    nome_consumidor: string,
    cpf_cnpj: string,
    rua_consumidor: string,
    cep_consumidor: string,
    numero_consumidor: string,
    bairro_consumidor: string,
    uf_consumidor: string,
    id_cidade_consumidor: number,
    id_user_cancel: number,
    dh_cancel: string,
    id_user_venda: number,
    name_user_venda: string,
    name_user_insert: string,
    itens: [
        {
            id: number,
            nitem: number,
            id_produto: number,
            desc_prod: string,
            cod_barra: string,
            qtde: number,
            vl_unit: number,
            vl_custo: number,
            vl_tot: number,
            vl_desc: number,
            vl_bc_icms: number,
            p_icms: number,
            cst_icms: string,
            origem_produto: string,
            vl_icms: number,
            vl_bc_pis_cofins: number,
            p_pis: number,
            vl_pis: number,
            p_cofins: number,
            vl_cofins: number,
            cst_pis_cofins: string,
            vl_bc_st: number,
            vl_st: number,
            vl_frete: number,
            status: string,
            dh_insert: string,
            dh_cancel: string,
            id_user_cancel: number,
            id_user_last_update: number,
            dt_last_update: string,
            desc_unid_medida: string,
            observacao: string,
        }
    ],
    pagamentos: [
        {
            id_fpagto: number,
            valor: number,
            descricao: string
        }
    ],
    DadosCliente: {
        id: number,
        nome: string,
        endereco: string,
        bairro: string,
        numero: string,
        cnpj_cpf: string,
        ie_rg: string,
        nome_cidade: string,
        cep: string,
        uf: string,
        nome_fantasia: string,
        complemento: string,
        contato: {
            telefone: string,
            celular: string,
            nome: string,
            email: string
        }
    },
    Crediario: [
        {
            data_vencimento: string,
            serie: number,
            valor: number,
            observacao: string,
            dt_cadastro: string
        },
    ]

}

export type ConsultaVendas = {
    vendas: RelatorioConsultaVendas[],
}

// ------------------------------------------------------------------  BANCOS ------------------------------------------------------------------------
export type BancoAttributes = {
    id: number,
    description: string,
    cod_banco: number
}

export type BancoSearchBox = {
    id: number,
    description: string,
}

// ------------------------------------------------------------------  CHEQUES ------------------------------------------------------------------------
export type Cheque = {
    id: number,
    tipo_cheque: string,
    data_lancamento: string,
    id_banco: number,
    agencia: number,
    agencia_digito: string,
    conta: number,
    conta_digito: string,
    numero: string,
    valor: number,
    id_cliente?: number,
    nome_terceiro?: string,
    dt_bom_para?: string,
    observacao?: string,
    status: string,

    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_delete?: number,
    id_user_baixa?: number,

    dt_cadastro?: string,
    dt_last_update?: string,
    dh_delete?: string,
    data_baixa?: string,

    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,

    dt_representado?: string,
    destino_cheque?: string,
    dt_devolvido?: string,
    nome_cliente?: string,
    nome_banco?: string,
    selected?: boolean,

    motivo_delete?: string
}

export type ChequeEstorno = {
    data_baixa: string,
    observacao: string,
    valor: number,
    id_bordero: number,
    selected?: boolean,
    qtd: number,
}

export type DadosRelCheque = {
    cheque: Cheque[],
    qtdCheque: number,
    total: number
}

export type DadosRelChequeEstorno = {
    chequeEstorno: ChequeEstorno[],
    qtdCheque: number,
    total: number
}

export type LanctoChequeAttributes = {
    cheque: Cheque,
    bancos: BancoSearchBox[],
    clientes: ClientesSearchBox[]
}

export type ParamsSaveCheque = {
    id: number,
    tipo_cheque: string,
    nome_terceiro: string,
    id_banco: number,
    conta: string,
    conta_digito: string,
    data_lancamento: string,
    dt_bom_para: string,
    agencia: string,
    agencia_digito: string,
    numero: string,
    valor: number,
    status: string,
    id_cliente: number,
    observacao: string,
}

export type ParamsLiqCheque = {
    data_baixa: string,
    observacao?: string,
    vl_bruto: number,
    vl_pagar: number,
    senha_usuario: string,
    cheques: number[],
    lanctoContasList: LanctoContaPag[],
}

export type ParamsEstCheque = {
    senha_usuario: string,
    cheque: number[],
    lanctoContasList: LanctoContaPag[],
    bordero: number[],
    motivo: string,
}

// ------------------------------------------------------------------  SANGRIA ------------------------------------------------------------------------
export type SangriaSuprimento = {
    id?: number,
    data: string,
    observacao: string,
    valor: number,
    tipo: TipoSangriaSuprimento,
    dh_insert?: string,
}

// ------------------------------------------------------------------  CAIXA ------------------------------------------------------------------------
export type CaixaRelatorio = {
    sup_sangrias_list: SangriaSuprimento[],
    empresa: DadosEmpresaCaixa,
    resumo_recebimento: ResumoRecebimento[],
    resumo_vendas: ResumoVendas[],
    tot_suprimento: number,
    tot_sangria: number,
}

export type ResumoRecebimento = {
    valor: number,
    descricao: string,
    tipo: string
}

export type ResumoVendas = {
    valor: number,
    descricao: string,
    tipo: string
}

export type DadosCaixaRelatorio = {
    data: string,
    id_vendedor: number
}

export type DadosEmpresaCaixa = {
    razao: string,
    nome_fantasia: string,
    bairro: string,
    numero: string,
    endereco: string,
    uf: string,
    cep: number,
    complemento: string,
    cidade: string,
    cnpj_cpf: string,
    ie_rg: string
}

export type Caixa = {
    id: number,
    data: string,
    valor: number,
    historico?: string,
    desc_conta?: string,
    dtCadastro?: string,
    nameUserInsert?: string,
    tipo: TipoLanctoCaixa,
    tipoLancto: string,
    idConta: number,
    acumulado?: number,
}

export type CaixaTransferencia = {
    idContaOrigem: number
    idContaDestino: number
    valor: number
    data: string
    historico: string
}

export type RegimeTributarioType = "MEI" | "LR" | "LP" | "SN"

// ------------------------------------------------------------------  BANDEIRA ------------------------------------------------------------------------
export type Bandeira = {
    id: number,
    id_empresa: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    dt_cadastro: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,
    nome: string,
    nome_resumido?: string,
    cnpj?: string,
    taxa: number,
    dias: string,
    description: string,
}

export type BandeiraSearchBox = {
    id: number,
    description: string,
}

// ------------------------------------------------------------------  LANCTO CARTAO -------------------------------------------------------------------
export type DadosRelLanctoCartao = {
    lanctoCartao: LanctoCartao[],
    total: number,
    qtd: number,
}

export type LanctoCartao = {
    id: number,
    id_empresa: number,
    id_user_insert?: number,
    id_user_last_update?: number,
    id_user_exclusao?: number,
    id_venda: number,
    id_bordero: number,
    dt_chegada: string,
    dt_vencimento: string,
    dt_cadastro: string,
    dt_last_update?: string,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_insert?: string,
    name_user_last_update?: string,
    name_user_delete?: string,
    hora?: string,
    valor: number,
    valor_receber?: number,
    id_bandeira: number,
    numero_transacao?: string,
    id_cliente?: number
    name_bandeira?: string,
    name_cliente?: string,
    selected?: boolean,

}

export type LanctoCartaoaAttributes = {
    lanctoCartao: LanctoCartao,
    cliente: Clientes[],
    bandeira: Bandeira[],
    vendedor: Usuarios[]
}

export type ParamsLiqLanctoCartao = {
    data_baixa: string,
    observacao?: string,
    vl_bruto: number,
    vl_pagar: number,
    senha_usuario: string,
    lanctoCartao: number[],
    lanctoContasList: LanctoContaPag[],
}

export type ParamsEstLanctoCartao = {
    senha_usuario: string,
    lanctoCartao: number[],
    lanctoContasList: LanctoContaPag[],
    bordero: number[],
    motivo: string,
}

export type DadosBorderoLanctoCartao = {
    valor: number,
    valor_receber: number,
    id_bordero: number,
    nome_cliente: string,
    dt_baixa: string,
    obs_baixa: string,
    selected?: boolean,
    qtd: number,
}

export type DadosBorderoGeral = {
    lanctoCartao: DadosBorderoLanctoCartao[]
    total: number,
    qtd: number,
}


// ------------------------------------------------------------------- CLASSES -------------------------------------------------------------------------------------------
//export const classLabel = "absolute text-sm text-slate-400 dark:text-slate-400 duration-500 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white dark:bg-slate-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1",
export const classDivBackground = "h-full flex flex-col"
export const classDivBody = "h-full mr-2 mb-2 pl-4 pr-2 mt-[65px] cursor-default lg:ml-[230px] lg:pl-8 transition-all duration-500"
export const classDivTitulo = "p-2 cursor-default bg-white border rounded-md shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800"

//export const classInput = "w-full h-[37px] py-[5px] lg:h-[45px] px-3 lg:py-2.5 text-sm text-slate-900 cursor-pointer focus:cursor-text bg-transparent border border-slate-400 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-blue-900 peer"

export const classInput = "w-full h-[45px] px-3 py-2.5 text-sm text-slate-900 cursor-pointer focus:cursor-text bg-transparent border border-slate-400 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-blue-900 peer disabled:cursor-not-allowed disabled:opacity-70"
export const classInputDark = "dark:text-slate-200 dark:bg-slate-500 dark:border-slate-700 dark:focus:border-slate-400"

export const classLabel = "absolute left-3 -top-[10px] px-1.5 text-[13px] text-slate-600 peer-focus:text-blue-900 bg-white"
export const classLabelDark = "dark:text-slate-200 dark:peer-focus:text-slate-200 dark:bg-slate-500 rounded-full"
export const classBorderLabelDark = "dark:border-2 dark:border-slate-600  dark:peer-focus:border-slate-400"

export const classBorderError = "border border-red-500 dark:border-red-600 focus:border-red-500 dark:focus:border-red-600"
export const classTextError = "text-red-600 dark:text-red-400 peer-focus:text-red-600 dark:peer-focus:text-red-400"

//export const classBtSalvar = "w-full h-[40px] min-w-[120px] sm:w-auto flex items-center justify-center bg-indigo-800 hover:bg-indigo-700 outline-double outline-1 outline-offset-1 outline-indigo-800 dark:outline-sky-500 dark:bg-sky-500 dark:hover:bg-sky-600 font-mono text-slate-200 dark:text-slate-200 text-sm p-2 rounded-lg transition-all duration-500"
//export const classBtPesquisar_Imprimir  = "w-full h-[40px] p-2 text-sm font-mono text-slate-100 rounded-md flex items-center justify-center duration-500"

export const classbtVermelho = "bg-[#e74c3c] hover:bg-[#c0392b]"
export const classbtHoverVermelho = ""
export const classbtVerde = "bg-green-600 hover:bg-green-700"
export const classbtCinza = "bg-[#939292] hover:bg-[#848383]"
export const classbtAzul = "bg-[#3498db] hover:bg-[#2980b9]"
export const classbtAzulEscuro = "bg-blue-500 hover:bg-blue-600"
export const classbtCinzaClaro = "bg-slate-500 hover:bg-slate-700"
export const classbtCeuAzul = "bg-sky-700 hover:bg-sky-800"

//export const classbtColunas         = "w-full h-[40px] p-2 text-sm font-medium text-slate-700 hover:text-slate-800 dark:text-slate-200 cursor-pointer bg-transparent border border-slate-400 hover:border-slate-600 dark:border-slate-400 dark:hover:border-slate-800 rounded-md flex items-center justify-center"
export const classbtColunasVermelho = "w-full h-[45px] p-2 text-sm font-medium text-slate-700 dark:text-slate-200 cursor-pointer bg-slate-100 dark:bg-transparent border border-slate-400 hover:border-red-600 hover:text-red-600 dark:hover:border-red-400 dark:hover:text-red-400 dark:border-slate-800 rounded-md flex items-center justify-center shadow-sm shadow-slate-400 dark:shadow-slate-800"

export const classbtColunasAzul = "w-full h-[45px] p-2 text-sm font-medium text-slate-700 hover:text-[#2980b9] dark:text-slate-200 cursor-pointer bg-slate-100 dark:bg-transparent border border-slate-400 hover:border-[#2980b9] dark:border-slate-800 dark:hover:border-[#D2C85F] rounded-md flex items-center justify-center dark:hover:text-[#D2C85F] shadow-sm shadow-slate-400 dark:shadow-slate-800"
export const classBt = "w-full h-[45px] p-2 text-sm font-medium text-slate-100 shadow-sm shadow-slate-500 dark:shadow-slate-800 rounded-md flex items-center justify-center duration-300"
export const classBtSemDuration = "w-full h-[45px] p-2 text-sm font-medium text-slate-100 shadow-sm shadow-slate-500 dark:shadow-slate-800 rounded-md flex items-center justify-center "
export const classBtModal = "max-w-[150px] text-black dark:text-slate-100 border border-slate-400 dark:border-slate-800 hover:bg-slate-200 dark:hover:bg-slate-500 mx-3"

export const corBgGrid = "#0369A1"

export const classWeigthBt = "sm:max-w-[140px] sm:min-w-[140px]"
export const classWeigthBt2XL = "2xl:min-w-[160px]"

export const classWeigthDiv = "min-w-[160px]"
export const classWeigthDiv2XL = "2xl:min-w-[140px]"

export const barraVermelhoAzul = "absolute top-[0px] bottom-[0px] dark:top-[1px] dark:bottom-[1px] w-[4px] mr-2 rounded-bl-md rounded-tl-md z-10"

export const bgBlue = "bg-[#172554]"
export const bgRed = "bg-red-900"
export const focusRed = "focus:outline-none focus:ring-0 focus:border-red-900 peer dark:focus:border-red-900"
export const focusLabelRed = "peer-focus:text-red-900 dark:peer-focus:border-red-900"

export const classbtColunasAzulEscuro = "w-full h-[40px] p-2 text-sm font-mono text-slate-700 hover:text-blue-600  dark:text-slate-200 cursor-pointer bg-transparent border border-slate-400 hover:border-blue-600  dark:border-slate-400 dark:hover:border-slate-800 rounded-md flex items-center justify-center"
export const bgLineGridColorDark = 'rgba(203, 213, 225, 0.4)'
export const bgLineGridColorLight = '#ccc'


export const classUserCriarAtt = 'text-slate-500 dark:text-slate-100 cursor-auto text-[14px] font-mono font-semibold'
export const classDtCriarAtt = 'w-full pt-1 text-slate-800 dark:text-slate-300 text-base cursor-auto'